import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';

const MODULE_PREFIX = '[ GUEST_LOGIN_V2 ]';

const Actions = {
	fetchGuestScripPriceV2: `${MODULE_PREFIX} fetchScripDetail`,
	setGuestScripPriceV2: `${MODULE_PREFIX} setGuestScripPriceV2`,
};

export const fetchGuestScripPriceV2 = createAction(Actions.fetchGuestScripPriceV2);
export const setGuestScripPriceV2 = createAction(Actions.setGuestScripPriceV2);

export const getScripDetailPriceV2 = (state) => {
	const data = get(state, 'guestScripDetailV2.guestScripDetail', {});
	return data;
};

//initial state
const initialStage = {
	guestScripDetail: {},
};

//reducer
export default createReducer(initialStage, (builder) => {
	builder.addCase(setGuestScripPriceV2, (state, action) => {
		state.guestScripDetail = action.payload;
	});
});
